import * as React from 'react'

const ResumeOrBeginButton = ({ onClickFn, text, languageLocale }) => (
  <button className="quill-button focus-on-light green contained large" lang={languageLocale} onClick={onClickFn} type="button">
    {text}
  </button>)

export { ResumeOrBeginButton }
